// test2882
(2882 && 0);
